import { render, staticRenderFns } from "./ArticlesActions.vue?vue&type=template&id=717b6309&scoped=true&"
import script from "./ArticlesActions.vue?vue&type=script&lang=js&"
export * from "./ArticlesActions.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesActions.vue?vue&type=style&index=0&id=717b6309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b6309",
  null
  
)

export default component.exports